import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IActivityLog, IUserActivityLog } from "./types/_logging";
import { PaginationResponse, ResponseData } from "./types/_public";
const api = new APIClient();

const path = 'user-activity-log';
const path_log_admin = '/logs/admin-activities';
const statisticApi = {
  userActivityLogs(params: any): Promise<AxiosResponse<ResponseData<IUserActivityLog[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },
  activityLogs(params: any): Promise<AxiosResponse<ResponseData<IActivityLog[]> & PaginationResponse, any>> {
    const url = `${path_log_admin}`
    return api.get(url, params)
  },
}
export default statisticApi
